import { createRouter } from '@tanstack/react-router';
import { onSessionEnded, queryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';
import { NotFound } from './app/NotFound';
import { AppError } from './app/AppError';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // On desktop the page scrolls inside its panel (Shell.tsx), not the window.
  scrollToTopSelectors: ['#main'],
  defaultNotFoundComponent: NotFound,
  // Never the router's own "Something went wrong!" page: an outage waits and retries by itself.
  defaultErrorComponent: AppError,
});

// A 401 while signed in: back to sign in, and back here after.
onSessionEnded(() =>
  router.navigate({ to: '/login', search: { next: router.state.location.href } }),
);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    /** The order's chat view was opened from its order page, so back is one step back. */
    fromOrder?: boolean;
  }
}
